import BookItem from "../common/bookItem";
export default class VisibleSwitchLineChild extends BookItem {
    constructor(el, target) {
        super(el, target);
        this.el = el;
        this.connectNumber = this.el.connectNumber;

        if (this.connectNumber.length > 0) {
            this.target.visible = false;
        }

        this.target.gotoAndStop(0);
    }

    init() {

    }
}